import RankFifteen from '@assets/icons/rank-fifteen.svg'
import { Icon } from './Icon'

export const RankFifteenIcon = Icon(RankFifteen)
